import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-user\">\r\n<g>\r\n\t<path id=\"icon-user_路径_2001\" d=\"M7.7,11.5C3.9,11.5,1,14,1,17.6v0.4c0,1.9,3.1,1.9,6.9,1.9h4.1c3.7,0,6.9,0,6.9-1.9v-0.4\r\n\t\tc0-3.6-2.9-6.1-6.7-6.1H7.7L7.7,11.5z M9.8,10.5c2.9,0.1,5.4-2.2,5.5-5.2c-0.2-3-2.8-5.3-5.8-5.2c-2.8,0.2-5,2.4-5.2,5.2\r\n\t\tC4.4,8.3,6.9,10.6,9.8,10.5z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol